import React, { useMemo, Fragment, useState, useEffect, useContext } from 'react';
import { MaterialReactTable } from 'material-react-table';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useOutletContext } from 'react-router-dom';

const ClientTeamTable = ({ tableData, setTableData }) => {
    const {refClientAccountCmsData}=useOutletContext();

    const fetchClientTeamMemberCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';

    }
    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => `${row.FirstName} ${row.LastName}`,
                id: 'fullName',
                header: fetchClientTeamMemberCmsData('ClientTeamMembers.Name'),
                filterFn: 'contains',
            },
            {
                accessorKey: "EmailAddress",
                header: fetchClientTeamMemberCmsData('ClientTeamMembers.Email'),
                filterFn: 'contains',
            },
            {
                accessorKey: "JobRole",
                header: fetchClientTeamMemberCmsData('ClientTeamMembers.JobTitle'),
                filterFn: 'contains'
            },
            {
                accessorFn: (row) => `${row.PermissionCode} - ${row.PermissionDescription}`,
                id: 'permissionLevel',
                header: fetchClientTeamMemberCmsData('ClientTeamMembers.PermissionLevel'),
                filterFn: 'contains'
            },
        ],
        [],
    );

    /**delete table row by id */
    const removeClientTeamTableEntry = ({ idToBeRemoved }) => {
        const newList = !!tableData && tableData.filter((item) => {
            if (item.Id !== idToBeRemoved) {
                return item
            }
        })
        setTableData(newList)
    }

    return (
        <MaterialReactTable
            columns={columns}
            data={tableData || []}
            layoutMode="grid"
            enableGlobalFilter={false}
            enableDensityToggle={false}
            muiTablePaginationProps={{
                labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
            }}
            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: fetchClientTeamMemberCmsData('ClientTeamMembers.Actions'),
                },
                'mrt-row-drag': {
                    header: fetchClientTeamMemberCmsData('ClientTeamMembers.Move'),
                },
            }}
            enableTopToolbar={!!tableData && tableData.length ? true : false}
            enableBottomToolbar={!!tableData && tableData.length ? true : false}
            initialState={{
                density: 'compact',
            }}

            /** !!!!!!!!!! for drag and drop !!!!!!!!!! */
            /**for drag and drop */
            enableRowOrdering
            /**sorting is disabled infavour of drag and drop */
            enableSorting={false}
            muiTableBodyRowDragHandleProps={({ table }) => ({
                onDragEnd: () => {
                    const { draggingRow, hoveredRow } = table.getState();
                    if (hoveredRow && draggingRow) {
                        tableData.splice(
                            hoveredRow.index,
                            0,
                            tableData.splice(draggingRow.index, 1)[0],
                        );
                        setTableData([...tableData]);
                    }
                },
            })}

            /** !!!!!!!!!! row actions !!!!!!!!!! */
            enableRowActions
            renderRowActions={({ row, table }) => {
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                        <IconButton
                            onClick={() => {
                                const id = row.original.Id

                                removeClientTeamTableEntry({ idToBeRemoved: id })
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                )
            }}
        />
    )
}
export default ClientTeamTable